<app-header></app-header>
<div class="scheduler-container" [class.loading]="isGlobalLoading || isSubmitting">
  <mat-card class="schedule-card">
    <mat-card-header>
      <img mat-card-avatar src="assets/client-logo.png" alt="Clinic Logo" class="clinic-logo">
      <mat-card-title>{{ appConfig.displayName }}</mat-card-title>
      <mat-card-subtitle>{{appConfig.address}}</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <h3>Schedule New Appointment</h3>
      <form [formGroup]="appointmentForm">
        <div class="patient-type-selection">
          <label class="dropdown-label">Patient Type</label>
          <div class="custom-dropdown" [class.open]="dropdownOpen" [class.disabled]="isSubmitting">
            <div class="dropdown-selected" (click)="toggleDropdown()">
              <span>{{ getSelectedPatientTypeLabel() }}</span>
              <svg class="dropdown-arrow" [class.rotate]="dropdownOpen" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>
            <div class="dropdown-options" *ngIf="dropdownOpen">
              <div class="dropdown-option"
                   [class.selected]="appointmentForm.get('patientType')?.value === 'new-emergency'"
                   (click)="selectPatientType('new-emergency')">
                <span>New patient emergency/other</span>
                <svg *ngIf="appointmentForm.get('patientType')?.value === 'new-emergency'" class="check-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <div class="dropdown-option"
                   [class.selected]="appointmentForm.get('patientType')?.value === 'existing-emergency'"
                   (click)="selectPatientType('existing-emergency')">
                <span>Existing patient emergency/other</span>
                <svg *ngIf="appointmentForm.get('patientType')?.value === 'existing-emergency'" class="check-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <div class="dropdown-option"
                   [class.selected]="appointmentForm.get('patientType')?.value === 'existing-treatment-plan'"
                   (click)="selectPatientType('existing-treatment-plan')">
                <span>Existing patient current treatment Plan</span>
                <svg *ngIf="appointmentForm.get('patientType')?.value === 'existing-treatment-plan'" class="check-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div class="chat-input-container" *ngIf="showTreatmentInput">
          <mat-form-field appearance="outline" class="chat-input full-width">
            <mat-label>What dental treatment do you need?</mat-label>
            <textarea matInput
                      formControlName="appointmentDescription"
                      placeholder="E.g., Teeth cleaning, cavity filling, etc."
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      cdkAutosizeMinRows="3"
                      cdkAutosizeMaxRows="5"
                      maxlength="300"
                      [matAutocomplete]="auto"
                      (keydown.enter)="onEnter($event)"
                      (focus)="showSuggestions = true"
                      (blur)="hideSuggestions()"
                      class="full-width"></textarea>
            <mat-autocomplete #auto="matAutocomplete" class="auto-complete" (optionSelected)="onEnter(null)">
              <mat-option
                *ngFor="let treatment of filteredTreatments | async"
                [value]="treatment"
                class="suggestion-option">
                <mat-icon class="suggestion-icon">trending_up</mat-icon>
                {{treatment}}
              </mat-option>
            </mat-autocomplete>
            <button mat-icon-button
                    matSuffix
                    (click)="onAppointmentDescriptionSubmit()"
                    [disabled]="!appointmentForm.get('appointmentDescription')?.value || isLoading"
                    class="send-button">
              <mat-icon *ngIf="!isLoading">send</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div *ngIf="isLoading && (isAppointmentTypesLoading || isOperatoriesLoading || isSlotsLoading)" class="loading-spinner-container">
          <div class="loading-content">
            <mat-progress-spinner mode="indeterminate" diameter="40" color="primary"></mat-progress-spinner>
            <span class="loading-text">{{loadingStatus}}</span>
          </div>
        </div>

        <div class="form-row" *ngIf="isDataReady && isDatepickerVisible">
          <div class="date-picker-field">
            <!-- <mat-label>Date</mat-label> -->
            <mat-calendar
              #calendar
              [headerComponent]="customCalendarHeader"
              (selectedChange)="dateChanged($event)"
              [minDate]="minDate"
              [maxDate]="maxDate"
              [selected]="appointmentForm.get('date')?.value"
              [dateClass]="dateClass">
            </mat-calendar>
            <div *ngIf="isMonthLoading()" class="calendar-loading-overlay">
              <mat-progress-spinner mode="indeterminate" diameter="30" color="primary"></mat-progress-spinner>
            </div>
          </div>
        </div>

        <div class="form-row" *ngIf="isDataReady && !isLoading">
          <div class="slots-container" *ngIf="selectedDate">
            <h3 *ngIf="getObjectKeys(displayedSlots).length > 0">Select a time slot for <b>{{ userFriendlyDate }}:</b></h3>
            <p *ngIf="getObjectKeys(displayedSlots).length === 0">No available time slots for <b>{{ userFriendlyDate }}</b></p>

            <div class="slots-content" *ngIf="getObjectKeys(displayedSlots).length > 0">
              <div *ngFor="let operatory of getObjectKeys(displayedSlots); trackBy: trackByOperatory">
                <h4>Room {{ operatory }}</h4>
                <mat-chip-listbox>
                  <mat-chip-option *ngFor="let slot of displayedSlots[operatory]; trackBy: trackBySlot"
                                   [selected]="slot === selectedSlot"
                                   (click)="selectSlot(slot, $event)">
                    <span class="time-slot-text">
                      {{ slot.start | date:'h:mm a' }}
                    </span>
                  </mat-chip-option>
                </mat-chip-listbox>

                <!-- Schedule button appears inside the room where time was selected -->
                <div class="room-schedule-button" *ngIf="selectedSlot && selectedSlot.operatory === operatory && !showConfirmation">
                  <button mat-raised-button class="schedule-button" (click)="showBookingConfirmation()" [disabled]="isSubmitting">
                    <mat-icon>event</mat-icon>
                    Schedule Appointment
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="slots-container" *ngIf="availableSlots.length == 0">
            <h3>No available time slots for this month</h3>
          </div>
        </div>
      </form>
    </mat-card-content>

  </mat-card>

  <div *ngIf="isSubmitting" class="global-loading-overlay">
    <mat-progress-spinner mode="indeterminate" diameter="80" color="primary"></mat-progress-spinner>
  </div>
</div>

<!-- Zocdoc-Style Immediate Booking Confirmation Modal - Use inline styles for maximum override -->
<!-- Remove animation that might cause positioning issues -->
<div *ngIf="showConfirmation"
     data-modal-overlay
     style="position: fixed !important; top: 0 !important; left: 0 !important; right: 0 !important; bottom: 0 !important; width: 100vw !important; height: 100vh !important; background: rgba(0, 0, 0, 0.6) !important; backdrop-filter: blur(8px) !important; z-index: 2147483647 !important; display: flex !important; align-items: center !important; justify-content: center !important; padding: 20px !important; margin: 0 !important; transform: none !important;">
  <div style="display: contents;">
    <div class="confirmation-card">
      <div class="confirmation-header">
        <h3>Schedule This Appointment?</h3>
        <button mat-icon-button (click)="hideBookingConfirmation()" class="close-button">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="confirmation-details">
        <div class="appointment-info">
          <div class="info-row">
            <mat-icon>calendar_today</mat-icon>
            <span>{{ userFriendlyDate }}</span>
          </div>
          <div class="info-row">
            <mat-icon>schedule</mat-icon>
            <span>{{ selectedSlot?.start | date:'h:mm a' }} - {{ selectedSlot?.end | date:'h:mm a' }}</span>
          </div>
          <div class="info-row">
            <mat-icon>meeting_room</mat-icon>
            <span>Room {{ selectedSlot?.operatory }}</span>
          </div>
          <div class="info-row">
            <mat-icon>person</mat-icon>
            <span>{{ getSelectedPatientTypeLabel() }}</span>
          </div>
        </div>
      </div>

      <div class="confirmation-actions">
        <button mat-button class="cancel-button" (click)="hideBookingConfirmation()" [disabled]="isSubmitting">
          Change Time
        </button>
        <button mat-raised-button class="confirm-button" (click)="confirmAppointment()" [disabled]="isSubmitting">
          <mat-progress-spinner *ngIf="isSubmitting" diameter="20" mode="indeterminate"></mat-progress-spinner>
          <span *ngIf="!isSubmitting">Book Appointment</span>
        </button>
      </div>
    </div>
  </div>
</div>
